module.exports = __webpack_public_path__ + "img/cca_en.a7f9c98e.png";